import { render, staticRenderFns } from "./ProjectBlock.vue?vue&type=template&id=78e28e0a&scoped=true&"
import script from "./ProjectBlock.vue?vue&type=script&lang=ts&"
export * from "./ProjectBlock.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectBlock.vue?vue&type=style&index=0&id=78e28e0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e28e0a",
  null
  
)

export default component.exports